(() => {
  'use strict';

  const q = (s, c = document) => c.querySelector(s);
  const qa = (s, c = document) => Array.from(c.querySelectorAll(s));


  const shopRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const escapeHtml = value => String(value == null ? '' : value).replace(/[&<>'"]/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','\"':'&quot;'}[ch]));
  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'USD' }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };
  const resizedImage = src => {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', '240');
      return url.toString();
    } catch (e) { return src; }
  };

  async function getCart() {
    const response = await fetch(`${shopRoot()}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!response.ok) throw new Error('Unable to load bag.');
    return response.json();
  }

  function updateCartCount(count) {
    qa('[data-rv-cart-count]').forEach(el => { el.textContent = String(count || 0); });
    qa('[data-rv-cart-open]').forEach(el => el.setAttribute('aria-label', `Cart with ${count || 0} items`));
  }

  function renderCartDrawer(cart) {
    const drawer = q('[data-rv-cart-drawer]');
    const body = drawer ? q('[data-rv-cart-drawer-body]', drawer) : null;
    if (!drawer || !body) return;
    updateCartCount(cart.item_count);

    if (!cart.item_count) {
      body.innerHTML = `
        <div class="rv-cart-drawer__empty">
          <h3>Your bag is quiet.</h3>
          <p>Start with the pieces designed to move with you.</p>
          <a href="${shopRoot()}collections/all">Shop all</a>
        </div>`;
      return;
    }

    const items = cart.items.map(item => {
      const image = item.image ? `<a class="rv-cart-drawer__media" href="${escapeHtml(item.url)}"><img src="${escapeHtml(resizedImage(item.image))}" alt="${escapeHtml(item.product_title)}" loading="lazy"></a>` : '<div class="rv-cart-drawer__media"></div>';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="rv-cart-drawer__variant">${escapeHtml(item.variant_title)}</p>` : '';
      return `
        <article class="rv-cart-drawer__line" data-rv-cart-line="${escapeHtml(item.key)}">
          ${image}
          <div class="rv-cart-drawer__meta">
            <h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3>
            ${variant}
            <div class="rv-cart-drawer__qty" aria-label="Quantity">
              <button type="button" data-rv-cart-change data-key="${escapeHtml(item.key)}" data-qty="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-rv-cart-change data-key="${escapeHtml(item.key)}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <button class="rv-cart-drawer__remove" type="button" data-rv-cart-change data-key="${escapeHtml(item.key)}" data-qty="0">Remove</button>
          </div>
          <div class="rv-cart-drawer__price">${money(item.final_line_price, cart.currency)}</div>
        </article>`;
    }).join('');

    const freeShippingTarget = 9900;
    const freeShippingRemaining = Math.max(0, freeShippingTarget - cart.total_price);
    const freeShippingProgress = Math.min(100, Math.max(0, (cart.total_price / freeShippingTarget) * 100));
    const freeShippingMessage = freeShippingRemaining > 0
      ? `${money(freeShippingRemaining, cart.currency)} away from free US shipping.`
      : `You qualify for free US shipping.`;

    body.innerHTML = `
      <div class="rv-cart-drawer__shipping">
        <div class="rv-cart-drawer__shipping-row"><span>FREE SHIPPING</span><strong>${freeShippingMessage}</strong></div>
        <div class="rv-cart-drawer__shipping-track"><i style="width:${freeShippingProgress}%"></i></div>
      </div>
      <div class="rv-cart-drawer__items">${items}</div>
      <div class="rv-cart-drawer__summary">
        <div class="rv-cart-drawer__subtotal"><span>Subtotal</span><strong>${money(cart.total_price, cart.currency)}</strong></div>
        <p class="rv-cart-drawer__note">Shipping and taxes are calculated at checkout.</p>
        <a class="rv-cart-drawer__checkout" href="${shopRoot()}checkout">Continue to checkout</a>
      </div>`;
  }

  async function refreshCartDrawer() {
    const drawer = q('[data-rv-cart-drawer]');
    const body = drawer ? q('[data-rv-cart-drawer-body]', drawer) : null;
    if (body) body.setAttribute('aria-busy', 'true');
    try {
      const cart = await getCart();
      renderCartDrawer(cart);
      return cart;
    } finally {
      if (body) body.removeAttribute('aria-busy');
    }
  }

  async function openCartDrawer(cartData = null) {
    const drawer = q('[data-rv-cart-drawer]');
    if (!drawer) {
      window.location.assign(`${shopRoot()}cart`);
      return;
    }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('rv-cart-open');
    const panel = q('.rv-cart-drawer__panel', drawer);
    window.setTimeout(() => panel?.focus(), 20);
    try { if (cartData) renderCartDrawer(cartData); else await refreshCartDrawer(); } catch (e) {
      const body = q('[data-rv-cart-drawer-body]', drawer);
      if (body) body.innerHTML = '<div class="rv-cart-drawer__empty"><h3>We could not load your bag.</h3><p>Please refresh the page and try again.</p></div>';
    }
  }

  function closeCartDrawer() {
    const drawer = q('[data-rv-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('rv-cart-open');
  }

  function initCartDrawer() {
    const drawer = q('[data-rv-cart-drawer]');
    if (!drawer || drawer.dataset.rvBound) return;
    drawer.dataset.rvBound = '1';
    qa('[data-rv-cart-open]').forEach(link => {
      if (link.dataset.rvCartBound) return;
      link.dataset.rvCartBound = '1';
      link.addEventListener('click', e => { e.preventDefault(); openCartDrawer(); });
    });
    qa('[data-rv-cart-close]', drawer).forEach(btn => btn.addEventListener('click', closeCartDrawer));
    drawer.addEventListener('click', async e => {
      const change = e.target.closest('[data-rv-cart-change]');
      if (!change) return;
      change.disabled = true;
      try {
        const response = await fetch(`${shopRoot()}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: change.dataset.key, quantity: Number(change.dataset.qty || 0) })
        });
        if (!response.ok) throw new Error('Unable to update bag.');
        const cart = await response.json();
        renderCartDrawer(cart);
        document.dispatchEvent(new CustomEvent('rivarie:cart:change', { detail: { cart } }));
      } catch (err) {
        change.disabled = false;
      }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCartDrawer(); });
  }

  function initGlobal() {
    initCartDrawer();
    const header = q('.rv-site-header');
    if (header) {
      const updateHeight = () => document.documentElement.style.setProperty('--rv-header-height', `${header.offsetHeight}px`);
      updateHeight();
      window.addEventListener('resize', updateHeight, { passive: true });
      const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 24 || !document.body.classList.contains('template-index'));
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    const hamb = q('#hamb');
    const mobile = q('#mobileNav');
    if (hamb && mobile && !hamb.dataset.rvBound) {
      hamb.dataset.rvBound = '1';
      const setOpen = (open) => {
        hamb.classList.toggle('open', open);
        mobile.classList.toggle('open', open);
        hamb.setAttribute('aria-expanded', String(open));
        hamb.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        mobile.setAttribute('aria-hidden', String(!open));
        document.body.classList.toggle('rv-menu-open', open);
        header?.classList.toggle('rv-mobile-menu-active', open);

        /* Mobile homepage header is transparent over the first hero. When the
           drawer opens, force the actual header chrome to a solid black-on-white
           state with inline !important styles so no transparent-header rule can
           hide the logo or the close icon. */
        if (header && window.matchMedia('(max-width: 640px)').matches) {
          const logo = q('.logo-wrap', header);
          const logoImg = logo ? q('img', logo) : null;
          const logoSvg = logo ? q('svg', logo) : null;
          const headerSvgs = qa('svg', header);
          const force = (el, prop, value) => el && el.style.setProperty(prop, value, 'important');
          const clear = (el, prop) => el && el.style.removeProperty(prop);

          if (open) {
            force(header, 'background', '#ffffff');
            force(header, 'background-color', '#ffffff');
            force(header, 'color', '#141414');
            force(header, 'opacity', '1');
            force(header, 'visibility', 'visible');
            force(header, 'overflow', 'visible');
            force(header, 'z-index', '10050');

            if (logo) {
              force(logo, 'display', 'flex');
              force(logo, 'visibility', 'visible');
              force(logo, 'opacity', '1');
              force(logo, 'color', '#141414');
              force(logo, 'z-index', '10060');
            }
            if (logoImg) {
              force(logoImg, 'display', 'block');
              force(logoImg, 'visibility', 'visible');
              force(logoImg, 'opacity', '1');
              force(logoImg, 'filter', 'brightness(0) saturate(100%)');
            }
            if (logoSvg) {
              force(logoSvg, 'display', 'block');
              force(logoSvg, 'visibility', 'visible');
              force(logoSvg, 'opacity', '1');
              force(logoSvg, 'color', '#141414');
            }
            headerSvgs.forEach(svg => force(svg, 'color', '#141414'));

            force(hamb, 'display', 'block');
            force(hamb, 'visibility', 'visible');
            force(hamb, 'opacity', '1');
            force(hamb, 'color', '#141414');
            force(hamb, 'z-index', '10070');
          } else {
            ['background','background-color','color','opacity','visibility','overflow','z-index'].forEach(prop => clear(header, prop));
            if (logo) ['display','visibility','opacity','color','z-index'].forEach(prop => clear(logo, prop));
            if (logoImg) ['display','visibility','opacity','filter'].forEach(prop => clear(logoImg, prop));
            if (logoSvg) ['display','visibility','opacity','color'].forEach(prop => clear(logoSvg, prop));
            headerSvgs.forEach(svg => clear(svg, 'color'));
            ['display','visibility','opacity','color','z-index'].forEach(prop => clear(hamb, prop));
          }
        }

        if (!open) qa('details[open]', mobile).forEach(detail => detail.removeAttribute('open'));
      };
      hamb.addEventListener('click', () => setOpen(!mobile.classList.contains('open')));
      qa('a', mobile).forEach(a => a.addEventListener('click', () => setOpen(false)));
      document.addEventListener('keydown', e => { if (e.key === 'Escape') setOpen(false); });
    }

    const loader = q('.rv-loader');
    if (loader && !loader.dataset.rvBound) {
      loader.dataset.rvBound = '1';
      const bar = q('#bar', loader), count = q('#count', loader);
      let value = 0;
      const finish = () => {
        if (bar) bar.style.width = '100%';
        if (count) count.textContent = '100';
        window.setTimeout(() => loader.classList.add('done'), 180);
      };
      const id = window.setInterval(() => {
        value = Math.min(94, value + Math.ceil(Math.random() * 9));
        if (bar) bar.style.width = `${value}%`;
        if (count) count.textContent = String(value).padStart(2, '0');
      }, 60);
      window.addEventListener('load', () => { clearInterval(id); finish(); }, { once: true });
      window.setTimeout(() => { clearInterval(id); finish(); }, 1600);
    }

    const heroStage = q('.lux-hero-stage');
    const heroOrbit = heroStage ? q('.lux-orbit', heroStage) : null;
    if (heroStage && heroOrbit && !heroStage.dataset.rvOrbitBound) {
      heroStage.dataset.rvOrbitBound = '1';
      let raf = 0, x = 0, y = 0;
      const draw = () => {
        raf = 0;
        const r = heroStage.getBoundingClientRect();
        const size = heroOrbit.offsetWidth || 94;
        const px = Math.max(size / 2, Math.min(r.width - size / 2, x - r.left));
        const py = Math.max(size / 2, Math.min(r.height - size / 2, y - r.top));
        heroOrbit.style.transform = `translate3d(${px - size / 2}px,${py - size / 2}px,0)`;
      };
      heroStage.addEventListener('pointerenter', e => { x=e.clientX; y=e.clientY; heroStage.classList.add('is-cursor-active'); draw(); });
      heroStage.addEventListener('pointermove', e => { x=e.clientX; y=e.clientY; if (!raf) raf=requestAnimationFrame(draw); });
      heroStage.addEventListener('pointerleave', () => heroStage.classList.remove('is-cursor-active'));
      qa('.lux-hero-actions a', heroStage).forEach(a => {
        a.addEventListener('pointerenter', () => heroStage.classList.add('is-cta-hover'));
        a.addEventListener('pointerleave', () => heroStage.classList.remove('is-cta-hover'));
      });
    }

    qa('.prm-filter button[data-url]').forEach(btn => {
      if (btn.dataset.rvBound) return;
      btn.dataset.rvBound = '1';
      btn.addEventListener('click', () => {
        qa('.prm-filter button', btn.parentElement).forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const url = btn.dataset.url;
        if (url && url !== '#' && !url.startsWith('#')) window.location.assign(url);
      });
    });
  }

  function initAccordions(root = document) {
    qa('.rv-accordion-trigger', root).forEach(btn => {
      if (btn.dataset.rvBound) return;
      btn.dataset.rvBound = '1';
      btn.addEventListener('click', () => {
        const item = btn.closest('.rv-accordion');
        if (!item) return;
        const open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });
    qa('.rv-faq-question', root).forEach(btn => {
      if (btn.dataset.rvBound) return;
      btn.dataset.rvBound = '1';
      btn.addEventListener('click', () => {
        const item = btn.closest('.rv-faq-item');
        if (!item) return;
        const open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  function initProduct(root) {
    if (!root || root.dataset.rvProductReady) return;
    root.dataset.rvProductReady = '1';
    const json = q('[data-rv-variants]', root);
    let variants = [];
    try { variants = JSON.parse(json?.textContent || '[]'); } catch (e) { variants = []; }
    const form = q('.rv-pdp-form', root);
    const idInput = q('[data-rv-variant-id]', root);
    const price = q('[data-rv-price]', root);
    const compare = q('[data-rv-compare]', root);
    const add = q('[data-rv-add]', root);
    const addLabel = q('[data-rv-add-label]', root);
    const addPrice = q('[data-rv-add-price]', root);
    const mobilePrice = q('[data-rv-mobile-price]', root);
    const mobileAdd = q('[data-rv-mobile-add]', root);
    const mobileLabel = q('[data-rv-mobile-add-label]', root);
    const desktopBar = q('[data-rv-desktop-bar]', root);
    const desktopPrice = q('[data-rv-desktop-price]', root);
    const desktopAdd = q('[data-rv-desktop-add]', root);
    const desktopLabel = q('[data-rv-desktop-add-label]', root);
    const lowStock = q('[data-rv-low-stock]', root);
    const soldoutHelp = q('[data-rv-soldout-help]', root);
    const notifyMeZone = q('[data-rv-notifyme-zone]', root);
    const dynamicCheckout = q('[data-rv-dynamic-checkout]', root);
    const requestSizeLinks = qa('[data-rv-request-size]', root);
    const notifyMeEnabled = String(root.dataset.notifyMeEnabled) === 'true';
    const lowStockThreshold = Number(root.dataset.lowStockThreshold || 5);
    const optionButtons = qa('[data-option-index][data-option-value]', root);
    let selected = [];

    qa('[data-rv-selected-option]', root).forEach(el => { selected[Number(el.dataset.rvSelectedOption)] = el.textContent.trim(); });

    const updateRequestSizeLinks = variant => {
      requestSizeLinks.forEach(link => {
        const sizeIndex = Number(link.dataset.sizeIndex || 0);
        const base = link.dataset.contactUrl || '/pages/contact';
        let url;
        try { url = new URL(base, window.location.origin); } catch (_) { return; }
        const size = (variant && Array.isArray(variant.options) ? variant.options[sizeIndex] : selected[sizeIndex]) || '';
        url.searchParams.set('request', 'size');
        url.searchParams.set('product', link.dataset.productTitle || document.title);
        url.searchParams.set('product_url', `${window.location.origin}${link.dataset.productUrl || window.location.pathname}`);
        if (variant && variant.id) url.searchParams.set('variant', variant.id);
        if (size) url.searchParams.set('size', size);
        link.href = url.pathname + url.search;
      });
    };

    const showMedia = mediaId => {
      if (!mediaId) return;
      qa('[data-media-id]', root).forEach(el => el.classList.toggle('is-active', String(el.dataset.mediaId) === String(mediaId)));
      qa('.rv-pdp-thumb[data-media-id]', root).forEach(el => el.classList.toggle('is-active', String(el.dataset.mediaId) === String(mediaId)));
    };

    const syncSelectedUI = () => {
      optionButtons.forEach(btn => {
        const i = Number(btn.dataset.optionIndex);
        const active = String(btn.dataset.optionValue) === String(selected[i]);
        btn.classList.toggle('is-selected', active);
        btn.setAttribute('aria-pressed', String(active));
      });
      qa('[data-rv-selected-option]', root).forEach(label => {
        const i = Number(label.dataset.rvSelectedOption);
        const activeButton = optionButtons.find(btn => Number(btn.dataset.optionIndex) === i && String(btn.dataset.optionValue) === String(selected[i]));
        label.textContent = activeButton?.dataset.optionDisplay || selected[i] || '';
      });
    };

    const exactVariant = () => variants.find(v => Array.isArray(v.options) && v.options.every((opt, i) => String(opt) === String(selected[i])));

    const resolveVariant = preferredIndex => {
      const exact = exactVariant();
      if (exact || preferredIndex == null || !selected[preferredIndex]) return exact || null;

      const wantedValue = String(selected[preferredIndex]);
      const candidates = variants
        .filter(v => Array.isArray(v.options) && String(v.options[preferredIndex]) === wantedValue)
        .map(v => {
          let score = v.available ? 100 : 0;
          v.options.forEach((opt, i) => {
            if (i !== preferredIndex && selected[i] && String(opt) === String(selected[i])) score += 10;
          });
          return { variant: v, score };
        })
        .sort((a, b) => b.score - a.score);

      const fallback = candidates[0]?.variant || null;
      if (fallback) {
        selected = fallback.options.slice();
        syncSelectedUI();
      }
      return fallback;
    };

    const update = (pushHistory = true, preferredIndex = null) => {
      if (!variants.length) return;
      const variant = resolveVariant(preferredIndex);
      if (!variant) {
        if (add) { add.disabled = true; add.classList.remove('is-rv-soldout'); }
        if (mobileAdd) mobileAdd.disabled = true;
        if (desktopAdd) desktopAdd.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        if (mobileLabel) mobileLabel.textContent = 'Unavailable';
        if (desktopLabel) desktopLabel.textContent = 'Unavailable';
        if (notifyMeZone) notifyMeZone.classList.add('is-hidden');
        if (dynamicCheckout) dynamicCheckout.classList.add('is-hidden');
        updateRequestSizeLinks(null);
        return;
      }
      if (idInput) {
        const changed = String(idInput.value) !== String(variant.id);
        idInput.value = variant.id;
        if (changed) {
          idInput.dispatchEvent(new Event('input', { bubbles: true }));
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      if (price) price.textContent = variant.price;
      if (mobilePrice) mobilePrice.textContent = variant.price;
      if (desktopPrice) desktopPrice.textContent = variant.price;
      if (compare) {
        compare.textContent = variant.compare || '';
        compare.classList.toggle('is-hidden', !variant.compare);
      }
      if (addPrice) addPrice.textContent = variant.available ? variant.price : '';
      const label = variant.available ? (root.dataset.addLabel || addLabel?.dataset.default || 'Add to bag') : (root.dataset.soldLabel || 'Sold out');
      if (addLabel) addLabel.textContent = label;
      if (mobileLabel) mobileLabel.textContent = label;
      if (desktopLabel) desktopLabel.textContent = label;
      if (add) {
        add.disabled = !variant.available;
        add.classList.toggle('is-rv-soldout', notifyMeEnabled && !variant.available);
      }
      if (mobileAdd) mobileAdd.disabled = !variant.available;
      if (desktopAdd) desktopAdd.disabled = !variant.available;
      const mobileBar = q('[data-rv-mobile-bar]', root);
      if (mobileBar) mobileBar.classList.toggle('is-rv-soldout', notifyMeEnabled && !variant.available);
      if (desktopBar) desktopBar.classList.toggle('is-rv-soldout', notifyMeEnabled && !variant.available);
      if (notifyMeZone) notifyMeZone.classList.toggle('is-hidden', variant.available);
      if (dynamicCheckout) dynamicCheckout.classList.toggle('is-hidden', !variant.available);
      const notifyManual = q('[data-rv-notifyme-manual]', root);
      if (notifyManual) {
        notifyManual.hidden = variant.available;
        notifyManual.setAttribute('aria-hidden', String(variant.available));
      }
      if (lowStock) lowStock.classList.toggle('is-hidden', !(variant.available && Number(variant.inventory) > 0 && Number(variant.inventory) <= lowStockThreshold));
      if (soldoutHelp) soldoutHelp.classList.toggle('is-hidden', variant.available);
      updateRequestSizeLinks(variant);
      document.dispatchEvent(new CustomEvent('rivarie:variant:change', { detail: { variantId: variant.id, available: variant.available } }));
      showMedia(variant.media_id);
      if (pushHistory && history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }

      optionButtons.forEach(btn => {
        const i = Number(btn.dataset.optionIndex);
        const val = String(btn.dataset.optionValue);
        const isColor = Boolean(btn.closest('.rv-option-values--color'));
        let matches;

        if (isColor) {
          matches = v => Array.isArray(v.options) && String(v.options[i]) === val;
        } else {
          matches = v => Array.isArray(v.options) && v.options.every((opt, ix) => {
            if (ix === i) return String(opt) === val;
            return !selected[ix] || String(opt) === String(selected[ix]);
          });
        }

        const exists = variants.some(matches);
        const inStock = variants.some(v => v.available && matches(v));
        const soldOut = exists && !inStock;
        btn.classList.toggle('is-disabled', !exists);
        btn.classList.toggle('is-soldout', soldOut);
        btn.disabled = !exists;
        btn.setAttribute('aria-disabled', String(!exists));
      });
    };

    optionButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled || btn.classList.contains('is-disabled')) return;
        const i = Number(btn.dataset.optionIndex);
        selected[i] = btn.dataset.optionValue;
        syncSelectedUI();
        update(true, i);
      });
    });

    qa('.rv-pdp-thumb[data-media-id]', root).forEach(btn => btn.addEventListener('click', () => showMedia(btn.dataset.mediaId)));

    const qty = q('.rv-qty input', root);
    q('[data-rv-qty-minus]', root)?.addEventListener('click', () => { if (qty) qty.value = Math.max(1, Number(qty.value || 1) - 1); });
    q('[data-rv-qty-plus]', root)?.addEventListener('click', () => { if (qty) qty.value = Math.max(1, Number(qty.value || 1) + 1); });

    const modal = q('[data-rv-size-modal]', root);
    const setModal = open => {
      if (!modal) return;
      modal.classList.toggle('is-open', open);
      modal.setAttribute('aria-hidden', String(!open));
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        const content = q('.rv-size-modal-content', modal);
        if (content) content.scrollTop = 0;
        qa('.rv-size-table__scroll', modal).forEach(scroller => { scroller.scrollLeft = 0; });
        window.setTimeout(() => q('.rv-size-modal-head [data-rv-size-close]', modal)?.focus(), 40);
      }
    };
    qa('[data-rv-size-guide]', root).forEach(btn => btn.addEventListener('click', () => setModal(true)));
    qa('[data-rv-size-close]', root).forEach(btn => btn.addEventListener('click', () => setModal(false)));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') setModal(false); });

    mobileAdd?.addEventListener('click', () => add?.click());
    desktopAdd?.addEventListener('click', () => add?.click());

    if (desktopBar && add && 'IntersectionObserver' in window) {
      const stickyObserver = new IntersectionObserver(entries => {
        const visible = !entries[0].isIntersecting && window.scrollY > 160;
        desktopBar.classList.toggle('is-visible', visible);
        desktopBar.setAttribute('aria-hidden', String(!visible));
      }, { threshold: 0.05 });
      stickyObserver.observe(add);
    }

    if (form && !form.dataset.rvBound) {
      form.dataset.rvBound = '1';
      form.addEventListener('submit', async e => {
        if (e.submitter && !e.submitter.matches('[data-rv-add]')) return;
        if (!add || add.disabled) return;
        e.preventDefault();
        const error = q('[data-rv-product-error]', root);
        if (error) { error.textContent = ''; error.classList.add('is-hidden'); }
        add.classList.add('is-loading');
        add.setAttribute('aria-busy', 'true');
        if (addLabel) addLabel.dataset.default = addLabel.textContent;
        try {
          const response = await fetch(`${shopRoot()}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            credentials: 'same-origin',
            body: new FormData(form)
          });
          if (!response.ok) {
            let message = 'This item could not be added to your bag.';
            try { const payload = await response.json(); message = payload.description || payload.message || message; } catch (_) {}
            throw new Error(message);
          }
          const cart = await getCart();
          updateCartCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('rivarie:cart:change', { detail: { cart } }));
          await openCartDrawer(cart);
        } catch (err) {
          if (error) { error.textContent = err.message || 'This item could not be added to your bag.'; error.classList.remove('is-hidden'); }
        } finally {
          add.classList.remove('is-loading');
          add.removeAttribute('aria-busy');
        }
      });
    }
    if (addLabel && !addLabel.dataset.default) addLabel.dataset.default = addLabel.textContent;
    update(false);
  }


  function initWishlist(scope = document) {
    const key = 'rivarie:wishlist:v2';
    let items = [];
    try {
      const raw = JSON.parse(localStorage.getItem(key) || '[]');
      items = Array.isArray(raw) ? raw.map(x => typeof x === 'object' ? x : { id:String(x) }) : [];
    } catch (_) {}
    const ids = () => items.map(x => String(x.id));
    const save = () => localStorage.setItem(key, JSON.stringify(items));
    const sync = () => {
      qa('[data-rv-wishlist]').forEach(btn => {
        const active = ids().includes(String(btn.dataset.productId || ''));
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', String(active));
        const title = btn.dataset.productTitle || 'item';
        btn.setAttribute('aria-label', `${active ? 'Remove' : 'Add'} ${title} ${active ? 'from' : 'to'} wishlist`);
      });
    };
    qa('[data-rv-wishlist]', scope).forEach(btn => {
      if (btn.dataset.rvWishlistBound) return;
      btn.dataset.rvWishlistBound = '1';
      btn.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation();
        const id = String(btn.dataset.productId || ''); if (!id) return;
        const exists = ids().includes(id);
        items = exists ? items.filter(x => String(x.id) !== id) : [...items, { id, handle:btn.dataset.productHandle || '', title:btn.dataset.productTitle || '' }];
        save(); sync(); renderWishlistPage();
        document.dispatchEvent(new CustomEvent('rivarie:wishlist:change', { detail: { items } }));
      });
    });
    async function renderWishlistPage(){
      const page = q('[data-rv-wishlist-page]'); if (!page) return;
      const grid=q('[data-rv-wishlist-grid]',page), empty=q('[data-rv-wishlist-empty]',page);
      const valid=items.filter(x=>x.handle);
      if (!valid.length){ if(grid) grid.innerHTML=''; if(empty) empty.hidden=false; return; }
      if(empty) empty.hidden=true;
      const products=(await Promise.all(valid.map(async item=>{try{const r=await fetch(`${shopRoot()}products/${encodeURIComponent(item.handle)}.js`,{credentials:'same-origin'});return r.ok?await r.json():null}catch(_){return null}}))).filter(Boolean);
      if(!grid) return;
      grid.innerHTML=products.map(p=>{const img=(p.featured_image||p.images?.[0]||''); const price=(p.price/100).toLocaleString(undefined,{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}); return `<article class="rv-wishlist-item"><a class="rv-wishlist-item-media" href="${shopRoot()}products/${encodeURIComponent(p.handle)}">${img?`<img src="${escapeHtml(resizedImage(img))}" alt="${escapeHtml(p.title)}" loading="lazy">`:''}</a><div class="rv-wishlist-item-meta"><div><h2><a href="${shopRoot()}products/${encodeURIComponent(p.handle)}">${escapeHtml(p.title)}</a></h2><p>${price}</p></div><button type="button" data-rv-wishlist data-product-id="${p.id}" data-product-handle="${escapeHtml(p.handle)}" data-product-title="${escapeHtml(p.title)}" aria-label="Remove ${escapeHtml(p.title)} from wishlist">Remove</button></div></article>`}).join('');
      initWishlist(grid);
    }
    sync(); renderWishlistPage();
  }

  function initShopTheLook(scope = document) {
    qa('[data-rv-look-add]', scope).forEach(btn => {
      if (btn.dataset.rvLookBound) return;
      btn.dataset.rvLookBound = '1';
      btn.addEventListener('click', async e => {
        e.preventDefault(); e.stopPropagation();
        btn.classList.add('is-loading');
        try {
          const response = await fetch(`${shopRoot()}cart/add.js`, { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, credentials:'same-origin', body:JSON.stringify({items:[{id:Number(btn.dataset.variantId),quantity:1}]}) });
          if (!response.ok) throw new Error('Unable to add');
          const cart = await getCart(); updateCartCount(cart.item_count); document.dispatchEvent(new CustomEvent('rivarie:cart:change',{detail:{cart}})); await openCartDrawer(cart);
        } catch (_) { window.location.href = shopRoot() + 'cart'; }
        finally { btn.classList.remove('is-loading'); }
      });
    });
  }

  function initHeroCarousels(scope = document) {
    qa('[data-rv-hero-carousel]', scope).forEach(root => {
      if (root.dataset.rvCarouselBound) return;
      root.dataset.rvCarouselBound = '1';
      const slides = qa('[data-rv-hero-slide]', root);
      if (slides.length < 2) return;
      const prev = q('[data-rv-hero-prev]', root);
      const next = q('[data-rv-hero-next]', root);
      const current = q('[data-rv-hero-current]', root);
      const total = q('[data-rv-hero-total]', root);
      const autoplay = root.dataset.autoplay === 'true';
      const delay = Math.max(3500, Number(root.dataset.autoplayMs || root.dataset.interval || 6000));
      let index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      let timer = 0;
      if (total) total.textContent = String(slides.length).padStart(2, '0');
      const show = (nextIndex, userAction = false) => {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        if (current) current.textContent = String(index + 1).padStart(2, '0');
        if (userAction) restart();
      };
      const stop = () => { if (timer) window.clearInterval(timer); timer = 0; };
      const start = () => { stop(); if (autoplay && !document.hidden) timer = window.setInterval(() => show(index + 1), delay); };
      const restart = () => { if (autoplay) start(); };
      prev?.addEventListener('click', () => show(index - 1, true));
      next?.addEventListener('click', () => show(index + 1, true));
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      show(index);
      start();
    });
  }

  function initSearchOverlay(scope = document) {
    const overlay = q('[data-rv-search-overlay]');
    if (!overlay || overlay.dataset.rvSearchBound) return;
    overlay.dataset.rvSearchBound = '1';
    const input = q('[data-rv-search-input]', overlay);
    const form = q('[data-rv-search-form]', overlay);
    const triggers = qa('[data-rv-search-open]');
    const setOpen = open => {
      overlay.classList.toggle('is-open', open);
      overlay.setAttribute('aria-hidden', String(!open));
      document.body.classList.toggle('rv-search-open', open);
      triggers.forEach(btn => btn.setAttribute('aria-expanded', String(open)));
      if (open) window.setTimeout(() => {
        input?.focus();
        if (input?.value) input.select();
      }, 80);
    };
    triggers.forEach(btn => {
      if (btn.dataset.rvSearchTriggerBound) return;
      btn.dataset.rvSearchTriggerBound = '1';
      btn.addEventListener('click', () => setOpen(true));
    });
    qa('[data-rv-search-close]', overlay).forEach(btn => btn.addEventListener('click', () => setOpen(false)));
    form?.addEventListener('submit', e => {
      if (!input?.value.trim()) {
        e.preventDefault();
        window.location.assign(`${shopRoot()}collections/all`);
      }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && overlay.classList.contains('is-open')) setOpen(false); });
  }

  function initBwFilms(scope = document) {
    qa('[data-rv-bw-film] video', scope).forEach(video => {
      if (video.dataset.rvFilmBound) return;
      video.dataset.rvFilmBound = '1';
      video.addEventListener('timeupdate', () => {
        if (video.duration > 10.2 && video.currentTime >= 10) video.currentTime = 0;
      });
    });
  }

  function initCardQuickAdd(scope = document) {
    qa('[data-rv-card-quick-add]', scope).forEach(btn => {
      if (btn.dataset.rvQuickBound) return;
      btn.dataset.rvQuickBound = '1';
      btn.addEventListener('click', async e => {
        e.preventDefault(); e.stopPropagation();
        const id = Number(btn.dataset.variantId || 0);
        if (!id || btn.disabled) return;
        btn.disabled = true; btn.classList.add('is-loading');
        try {
          const response = await fetch(`${shopRoot()}cart/add.js`, {
            method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
            credentials:'same-origin', body:JSON.stringify({items:[{id,quantity:1}]})
          });
          if (!response.ok) throw new Error('Unable to add');
          const cart = await getCart(); updateCartCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('rivarie:cart:change',{detail:{cart}}));
          await openCartDrawer(cart);
        } catch (_) {
          window.location.assign(btn.dataset.productUrl || `${shopRoot()}cart`);
        } finally { btn.disabled = false; btn.classList.remove('is-loading'); }
      });
    });
  }


  function initSearchCardSizeSelect(scope = document) {
    qa('[data-rv-search-size-select]', scope).forEach(btn => {
      if (btn.dataset.rvSearchSizeBound) return;
      btn.dataset.rvSearchSizeBound = '1';

      btn.addEventListener('click', async e => {
        e.preventDefault();
        e.stopPropagation();

        if (btn.disabled || btn.classList.contains('is-loading')) return;

        const card = btn.closest('.rv-card');
        if (!card) return;

        const id = Number(btn.dataset.variantId || 0);
        if (!id) return;

        qa('[data-rv-search-size-select]', card).forEach(sizeBtn => {
          sizeBtn.classList.toggle('is-selected', sizeBtn === btn);
        });

        card.dataset.rvSelectedVariant = String(id);
        btn.disabled = true;
        btn.classList.add('is-loading');

        try {
          const response = await fetch(`${shopRoot()}cart/add.js`, {
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
            credentials:'same-origin',
            body:JSON.stringify({items:[{id,quantity:1}]})
          });
          if (!response.ok) throw new Error('Unable to add');

          const cart = await getCart();
          updateCartCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('rivarie:cart:change',{detail:{cart}}));
          await openCartDrawer(cart);
        } catch (_) {
          window.location.assign(btn.dataset.productUrl || `${shopRoot()}cart`);
        } finally {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        }
      });
    });
  }

  function initCardColorSwatches(scope = document) {
    const normalize = value => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
    const variantsForCard = card => {
      const node = q('[data-rv-card-variant-data]', card);
      if (!node) return [];
      try { return JSON.parse(node.textContent || '[]'); } catch (_) { return []; }
    };

    qa('[data-rv-card-color-swatch]', scope).forEach(swatch => {
      const collectionShell = swatch.closest('.rv-collection');
      const isSearchCard = Boolean(swatch.closest('.rv-search-direct, .template-search'));
      /* Search has its own preloaded color-layer controller in templates/search.liquid.
         Do not mutate the base image here first or the customer sees a broken flash. */
      if (isSearchCard) return;
      if (collectionShell) return;
      if (swatch.dataset.rvColorBound) return;
      swatch.dataset.rvColorBound = '1';

      swatch.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        const card = swatch.closest('.rv-card');
        if (!card) return;
        const group = swatch.closest('.rv-card-swatches');
        if (group) {
          qa('[data-rv-card-color-swatch]', group).forEach(item => {
            const active = item === swatch;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
        }

        const primary = q('.rv-card-image--primary', card);
        const secondary = q('.rv-card-image--secondary', card);
        const src = swatch.dataset.imageSrc;
        if (primary && src) {
          ['data-src','data-srcset','data-lazy-src','data-lazy-srcset'].forEach(attr => primary.removeAttribute(attr));
          primary.src = src;
          primary.removeAttribute('srcset');
          primary.removeAttribute('sizes');
          card.classList.add('is-variant-selected');
          if (secondary) secondary.style.opacity = '0';
        }

        const variantUrl = swatch.dataset.variantUrl;
        if (variantUrl) {
          const mediaLink = q('.rv-card-media-link', card);
          const titleLink = q('.rv-card-title a', card);
          if (mediaLink) mediaLink.href = variantUrl;
          if (titleLink) titleLink.href = variantUrl;
        }

        const color = normalize(swatch.dataset.colorName || swatch.title || '');
        const variants = variantsForCard(card);
        if (variants.length && color) {
          qa('[data-rv-card-size]', card).forEach(sizeBtn => {
            const size = normalize(sizeBtn.dataset.rvCardSize || sizeBtn.textContent);
            const match = variants.find(v => normalize(v.color) === color && normalize(v.size) === size && v.available)
              || variants.find(v => normalize(v.color) === color && normalize(v.size) === size);
            const available = Boolean(match && match.available);
            sizeBtn.disabled = !available;
            if (match && match.id) {
              sizeBtn.dataset.variantId = String(match.id);
              if (match.url) sizeBtn.dataset.productUrl = match.url;
            } else {
              sizeBtn.removeAttribute('data-variant-id');
            }
            if (!available) sizeBtn.classList.remove('is-selected');
          });

          const searchSizes = qa('[data-rv-search-size-select]', card).filter(btn => !btn.disabled && btn.dataset.variantId);
          const selectedSearchSize = searchSizes.find(btn => btn.classList.contains('is-selected')) || searchSizes[0];
          if (selectedSearchSize) {
            searchSizes.forEach(btn => btn.classList.toggle('is-selected', btn === selectedSearchSize));
          }
          const searchAdd = q('[data-rv-search-add-to-cart]', card);
          if (searchAdd) {
            if (selectedSearchSize && selectedSearchSize.dataset.variantId) {
              searchAdd.dataset.variantId = selectedSearchSize.dataset.variantId;
              searchAdd.disabled = false;
            } else {
              searchAdd.disabled = true;
              searchAdd.removeAttribute('data-variant-id');
            }
          }
        }
      });
    });
  }


  function initSearchSwatchImageSync() {
    /* The direct Search template owns swatch imagery; avoid duplicate image writes. */
    if (document.querySelector('.rv-search-direct')) return;
    if (document.documentElement.dataset.rvSearchSwatchImageSyncBound) return;
    document.documentElement.dataset.rvSearchSwatchImageSyncBound = '1';

    const normalize = value => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
    const getVariants = card => {
      const node = q('[data-rv-card-variant-data]', card);
      if (!node) return [];
      try { return JSON.parse(node.textContent || '[]'); } catch (_) { return []; }
    };

    const applySelectedColor = swatch => {
      const card = swatch && swatch.closest ? swatch.closest('.rv-card, [data-rv-product-card]') : null;
      if (!card) return;
      if (!card.closest('.rv-search') && !document.body.classList.contains('template-search')) return;

      const color = normalize(swatch.dataset.colorName || swatch.title || swatch.getAttribute('aria-label') || '');
      if (!color) return;

      const group = swatch.closest('.rv-card-swatches');
      if (group) {
        qa('[data-rv-card-color-swatch]', group).forEach(item => {
          const active = item === swatch;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
      }

      const variants = getVariants(card);
      const colorVariants = variants.filter(v => normalize(v.color) === color);
      const selectedSizeButton = q('[data-rv-search-size-select].is-selected, [data-rv-card-size].is-selected', card);
      const selectedSize = selectedSizeButton ? normalize(selectedSizeButton.dataset.rvCardSize || selectedSizeButton.textContent) : '';

      let selectedVariant = null;
      if (selectedSize) {
        selectedVariant = colorVariants.find(v => normalize(v.size) === selectedSize && v.available)
          || colorVariants.find(v => normalize(v.size) === selectedSize)
          || null;
      }
      if (!selectedVariant) selectedVariant = colorVariants.find(v => v.available) || colorVariants[0] || null;

      /* Product variant imagery is the source of truth on Search. If the exact size
         does not carry its own image, use another variant of the same color before
         falling back to the Liquid swatch image. */
      const imageVariant = (selectedVariant && selectedVariant.image ? selectedVariant : null)
        || colorVariants.find(v => v.available && v.image)
        || colorVariants.find(v => v.image)
        || null;
      /* On Search, the Shopify variant image is the source of truth. Do not let
         the pre-rendered swatch image override the image assigned to the selected
         color variant. */
      const imageSrc = (imageVariant && imageVariant.image) || swatch.dataset.imageSrc || '';

      const primary = q('.rv-card-image--primary', card) || q('.rv-card-media img:first-of-type', card);
      const secondary = q('.rv-card-image--secondary', card);
      if (primary && imageSrc) {
        const picture = primary.closest('picture');
        if (picture) {
          qa('source', picture).forEach(source => {
            source.setAttribute('srcset', imageSrc);
            source.setAttribute('data-srcset', imageSrc);
          });
        }
        primary.setAttribute('src', imageSrc);
        primary.setAttribute('srcset', imageSrc);
        primary.setAttribute('data-src', imageSrc);
        primary.setAttribute('data-srcset', imageSrc);
        primary.removeAttribute('data-lazy-src');
        primary.removeAttribute('data-lazy-srcset');
        primary.src = imageSrc;
        primary.style.setProperty('opacity', '1', 'important');
        primary.style.setProperty('visibility', 'visible', 'important');
        primary.classList.add('rv-card-image--color-selected');
        card.classList.add('is-variant-selected');
        if (secondary) {
          secondary.style.setProperty('opacity', '0', 'important');
          secondary.style.setProperty('visibility', 'hidden', 'important');
          secondary.setAttribute('aria-hidden', 'true');
        }
      }

      const variantUrl = (selectedVariant && selectedVariant.url) || swatch.dataset.variantUrl || '';
      if (variantUrl) {
        qa('.rv-card-media-link, .rv-card-title a', card).forEach(link => { link.href = variantUrl; });
        qa('[data-product-url]', card).forEach(el => { el.dataset.productUrl = variantUrl; });
      }

      if (selectedVariant && selectedVariant.id) {
        const add = q('[data-rv-search-add-to-cart]', card);
        if (add) {
          add.dataset.variantId = String(selectedVariant.id);
          add.disabled = !selectedVariant.available;
        }
      }
    };

    /* Run after the swatch's own click handler, then once more on the next frame.
       This prevents older theme/card handlers from restoring the previous photo. */
    document.addEventListener('click', event => {
      const target = event.target;
      const swatch = target && target.closest ? target.closest('[data-rv-card-color-swatch]') : null;
      if (!swatch) return;
      if (!swatch.closest('.rv-search') && !document.body.classList.contains('template-search')) return;
      event.preventDefault();
      applySelectedColor(swatch);
      window.requestAnimationFrame(() => applySelectedColor(swatch));
    });
  }

  function initCardFirstTapNavigation(scope = document) {
    const links = [];
    if (scope && scope.matches && scope.matches('.rv-card-media-link')) links.push(scope);
    qa('.rv-card-media-link', scope).forEach(link => { if (!links.includes(link)) links.push(link); });

    links.forEach(link => {
      if (link.dataset.rvFirstTapBound) return;
      link.dataset.rvFirstTapBound = '1';
      let startX = 0, startY = 0, touching = false;

      link.addEventListener('touchstart', e => {
        if (!e.touches || e.touches.length !== 1) return;
        touching = true;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      link.addEventListener('touchend', e => {
        if (!touching || !e.changedTouches || e.changedTouches.length !== 1) return;
        touching = false;
        const dx = Math.abs(e.changedTouches[0].clientX - startX);
        const dy = Math.abs(e.changedTouches[0].clientY - startY);
        if (dx > 10 || dy > 10 || !link.href) return;
        e.preventDefault();
        e.stopPropagation();
        window.location.assign(link.href);
      }, { passive: false });

      link.addEventListener('touchcancel', () => { touching = false; }, { passive: true });
    });
  }

  function initCollectionAjax(scope = document) {
    const sections = [];
    if (scope && scope.matches && scope.matches('.rv-collection')) sections.push(scope);
    qa('.rv-collection', scope).forEach(section => { if (!sections.includes(section)) sections.push(section); });
    sections.forEach(section => {
      if (section.classList.contains('rv-search')) return;
      if (section.dataset.rvAjaxBound) return;
      section.dataset.rvAjaxBound = '1';
      const form = q('form.rv-collection-controls[data-rv-collection-form]', section);
      if (!form) return;
      const load = async url => {
        section.classList.add('is-loading'); section.setAttribute('aria-busy','true');
        try {
          const response = await fetch(url, {headers:{'X-Requested-With':'XMLHttpRequest'},credentials:'same-origin'});
          if (!response.ok) throw new Error('Unable to filter');
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html,'text/html');
          const fresh = q('.rv-collection', doc);
          if (!fresh) throw new Error('Missing collection');
          const topBefore = section.getBoundingClientRect().top + window.scrollY;
          fresh.setAttribute('aria-live','polite');
          section.replaceWith(fresh);
          window.history.pushState({},'',url);
          initAll(fresh);

          /* Keep the collection controls in roughly the same viewport position
             while updating filters/sort without a full-page reload. */
          const topAfter = fresh.getBoundingClientRect().top + window.scrollY;
          const delta = topAfter - topBefore;
          if (Math.abs(delta) > 1) window.scrollBy(0, delta);
        } catch (_) { window.location.assign(url); }
      };
      const urlForForm = () => {
        const data = new FormData(form), params = new URLSearchParams();
        data.forEach((value,key) => { if (String(value).trim() !== '') params.append(key,value); });
        const qs=params.toString(); return `${form.action}${qs ? `?${qs}` : ''}`;
      };
      form.addEventListener('change', e => {
        if (!e.target.matches('select,input[type="checkbox"],input[type="radio"]')) return;
        qa('details[open]', form).forEach(detail => detail.removeAttribute('open'));
        load(urlForForm());
      });
      form.addEventListener('submit', e => {
        e.preventDefault();
        qa('details[open]', form).forEach(detail => detail.removeAttribute('open'));
        load(urlForForm());
      });
      qa('.rv-active-filters a,.rv-pagination a', section).forEach(a => a.addEventListener('click', e => { e.preventDefault(); load(a.href); }));
    });
  }


  function initSearchFiltersAjax(scope = document) {
    const sections = [];
    if (scope && scope.matches && scope.matches('.rv-search')) sections.push(scope);
    qa('.rv-search', scope).forEach(section => { if (!sections.includes(section)) sections.push(section); });
    sections.forEach(section => {
      if (section.dataset.rvSearchAjaxBound) return;
      section.dataset.rvSearchAjaxBound = '1';
      const form = q('[data-rv-search-filters]', section);
      if (!form) return;
      const load = async url => {
        section.classList.add('is-loading'); section.setAttribute('aria-busy','true');
        try {
          const response = await fetch(url, {headers:{'X-Requested-With':'XMLHttpRequest'},credentials:'same-origin'});
          if (!response.ok) throw new Error('Unable to filter search');
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html,'text/html');
          const fresh = q('.rv-search', doc);
          if (!fresh) throw new Error('Missing search section');
          section.replaceWith(fresh);
          window.history.pushState({},'',url);
          initAll(fresh);
        } catch (_) { window.location.assign(url); }
      };
      const urlForForm = () => {
        const data = new FormData(form), params = new URLSearchParams();
        data.forEach((value,key) => { if (String(value).trim() !== '') params.append(key,value); });
        const qs=params.toString(); return `${form.action}${qs ? `?${qs}` : ''}`;
      };
      form.addEventListener('change', e => {
        if (!e.target.matches('select,input[type="checkbox"],input[type="radio"]')) return;
        qa('details[open]', form).forEach(detail => detail.removeAttribute('open'));
        load(urlForForm());
      });
      form.addEventListener('submit', e => {
        e.preventDefault();
        qa('details[open]', form).forEach(detail => detail.removeAttribute('open'));
        load(urlForForm());
      });
      qa('.rv-search-results .rv-pagination a', section).forEach(a => a.addEventListener('click', e => { e.preventDefault(); load(a.href); }));
    });
  }

  function initWriteReview(scope = document) {
    qa('[data-rv-write-review]', scope).forEach(btn => {
      if (btn.dataset.rvReviewBound) return;
      btn.dataset.rvReviewBound = '1';
      btn.addEventListener('click', e => {
        const reviews = q('#rivarie-reviews') || q('.rv-reviews');
        if (!reviews) return;
        const selectors = [
          '.jdgm-write-rev-link',
          '[data-judgeme-action="write-review"]',
          '.spr-summary-actions-newreview',
          '.R-Button--primary',
          'a[class*="write"][class*="review"]',
          'button[class*="write"][class*="review"]',
          'button[class*="review"]'
        ];
        const target = selectors.map(sel => q(sel, reviews)).find(Boolean);
        e.preventDefault();
        reviews.scrollIntoView({behavior:'smooth',block:'start'});
        if (target) window.setTimeout(()=>target.click(),350);
      });
    });
  }


  function initSearchPage(scope = document) {
    qa('[data-rv-search-page-form]', scope).forEach(form => {
      if (form.dataset.rvPageSearchBound) return;
      form.dataset.rvPageSearchBound = '1';
      const input = q('[data-rv-search-page-input]', form);
      form.addEventListener('submit', e => {
        if (!input?.value.trim()) { e.preventDefault(); window.location.assign(`${shopRoot()}collections/all`); }
      });
    });
  }


  function removeFloatingWishlistLauncher() {
    const selectors = [
      '#ssw-fave-side-button','.ssw-fave-side-button',
      '#ssw-fave-side-widget','.ssw-fave-side-widget',
      '#ssw-wishlist-side-button','.ssw-wishlist-side-button',
      '[class*="ssw-fave-side"]','[id*="ssw-fave-side"]',
      '[class*="wishlist-floating"]','[id*="wishlist-floating"]',
      '[class*="wishlist-float"]','[id*="wishlist-float"]',
      '[class*="wishlist-side-button"]','[id*="wishlist-side-button"]',
      '.swym-wishlist-launcher','.swym-wishlist-tab','.swym-floating-button',
      '#swym-wishlist-launcher','#swym-wishlist-tab'
    ];

    const hide = el => {
      if (!el || el.closest('.rv-site-header')) return;
      el.style.setProperty('display','none','important');
      el.style.setProperty('visibility','hidden','important');
      el.style.setProperty('pointer-events','none','important');
    };

    const scan = root => {
      if (!root || root.nodeType !== 1) return;
      selectors.forEach(selector => {
        if (root.matches && root.matches(selector)) hide(root);
        if (root.querySelectorAll) root.querySelectorAll(selector).forEach(hide);
      });

      /* Some wishlist apps inject an unhelpfully named fixed button.
         Hide only a fixed/sticky compact element whose entire label is Wishlist. */
      const candidates = root.matches && root.matches('a,button,div') ? [root] : [];
      if (root.querySelectorAll) candidates.push(...root.querySelectorAll('a,button,div'));
      candidates.forEach(el => {
        if (el.closest('.rv-site-header')) return;
        const label = (el.textContent || '').replace(/\s+/g,' ').trim().toLowerCase();
        if (label !== 'wishlist') return;
        const style = window.getComputedStyle(el);
        if (style.position !== 'fixed' && style.position !== 'sticky') return;
        const rect = el.getBoundingClientRect();
        if (rect.width > 360 || rect.height > 180) return;
        hide(el);
      });
    };

    scan(document.body);
    if (window.__rvWishlistLauncherObserver) return;
    window.__rvWishlistLauncherObserver = new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => scan(node)));
    });
    window.__rvWishlistLauncherObserver.observe(document.body,{childList:true,subtree:true});
  }

  function initAll(scope = document) {
    initGlobal();
    removeFloatingWishlistLauncher();
    initHeroCarousels(scope);
    initSearchOverlay(scope);
    initSearchPage(scope);
    initBwFilms(scope);
    initAccordions(scope);
    initWishlist(scope);
    initCardQuickAdd(scope);
    initSearchCardSizeSelect(scope);
    initCardColorSwatches(scope);
    initSearchSwatchImageSync();
    initCardFirstTapNavigation(scope);
    initCollectionAjax(scope);
    initSearchFiltersAjax(scope);
    initWriteReview(scope);
    initShopTheLook(scope);
    qa('[data-rv-product]', scope).forEach(initProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll()); else initAll();
  document.addEventListener('shopify:section:load', e => initAll(e.target));
  document.addEventListener('shopify:section:reorder', () => initAll());


  /* RIVARIE_FLOATING_WISHLIST_REMOVAL */
  function removeFloatingWishlistLaunchers(){
    const candidates = qa([
      '#ssw-fave-side-button','.ssw-fave-side-button','#ssw-fave-side-widget','.ssw-fave-side-widget',
      '[id*="ssw-fave"]','[class*="ssw-fave"]','[id*="ssw-wishlist"]','[class*="ssw-wishlist"]',
      '.swym-wishlist-launcher','.swym-wishlist-tab','.swym-floating-button','#swym-wishlist-launcher','#swym-wishlist-tab',
      '[id*="wishlist-launcher"]','[class*="wishlist-launcher"]','[id*="wishlist-floating"]','[class*="wishlist-floating"]',
      '[id*="wishlist-side"]','[class*="wishlist-side"]'
    ].join(','));
    candidates.forEach(el => {
      if (el.closest('.rv-site-header,.rv-wishlist-page')) return;
      let pos = '';
      try { pos = getComputedStyle(el).position; } catch (_) {}
      const cls = `${el.id || ''} ${el.className || ''}`.toLowerCase();
      const looksLauncher = /side|float|launcher|tab/.test(cls);
      const textIsWishlist = (el.textContent || '').trim().toLowerCase() === 'wishlist';
      if (looksLauncher || textIsWishlist || pos === 'fixed' || pos === 'sticky') el.remove();
    });
  }

  removeFloatingWishlistLaunchers();
  const rvWishlistObserver = new MutationObserver(removeFloatingWishlistLaunchers);
  rvWishlistObserver.observe(document.documentElement,{childList:true,subtree:true});

})();

/* =========================================================
   RIVARIE V24 — RELIABLE FILTER APPLY
   Applies collection/search filter changes immediately and closes the
   dropdown before navigation. Capture phase prevents older AJAX handlers
   from racing each other on iOS/Safari.
   ========================================================= */
(() => {
  if (window.__rvReliableFiltersV24) return;
  window.__rvReliableFiltersV24 = true;

  const FORM_SELECTOR = 'form[data-rv-collection-form], form[data-rv-search-filters-v20]';
  const CHOICE_SELECTOR = 'input[type="checkbox"], input[type="radio"], select';

  const closeAll = (form, except = null) => {
    if (!form) return;
    form.querySelectorAll('details.rv-filter[open]').forEach(detail => {
      if (detail !== except) detail.removeAttribute('open');
    });
  };

  const buildUrl = form => {
    const data = new FormData(form);
    const params = new URLSearchParams();
    data.forEach((value, key) => {
      if (String(value).trim() !== '') params.append(key, value);
    });
    const query = params.toString();
    return form.action + (query ? '?' + query : '');
  };

  /* Keep only one filter dropdown open at a time. */
  document.addEventListener('click', event => {
    const summary = event.target.closest && event.target.closest(`${FORM_SELECTOR} details.rv-filter > summary`);
    if (!summary) return;
    const form = summary.closest(FORM_SELECTOR);
    const current = summary.closest('details.rv-filter');
    closeAll(form, current);
  }, true);

  /* A filter/sort choice immediately closes and applies. */
  document.addEventListener('change', event => {
    const target = event.target;
    if (!target || !target.matches || !target.matches(CHOICE_SELECTOR)) return;
    const form = target.closest && target.closest(FORM_SELECTOR);
    if (!form) return;

    event.stopImmediatePropagation();
    closeAll(form);
    form.classList.add('is-filter-applying');

    const url = buildUrl(form);
    window.requestAnimationFrame(() => window.location.assign(url));
  }, true);

  /* Price filter Apply button / any explicit filter form submit. */
  document.addEventListener('submit', event => {
    const form = event.target.closest && event.target.closest(FORM_SELECTOR);
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    closeAll(form);
    form.classList.add('is-filter-applying');

    const url = buildUrl(form);
    window.requestAnimationFrame(() => window.location.assign(url));
  }, true);
})();
